import { useCallback, useState } from "react";
import { ROUTE_PATH_TO_ROUTE_KEY, routePagesFinder } from "Router";
import RoleContext from "./context";
import { useEnvs } from "state/EnvironmentsContext/EnvContext";
type IPermissions = { [key in string]: string[] };

const RoleProvider = ({ children }: { children: React.ReactNode }) => {
  const [permissions, setPermissions] = useState<IPermissions>({});
  const { isDevelopment } = useEnvs((state) => state);
  // assuming that the refresh function is called when the user enters the page
  const [isLoading, setLoading] = useState(true);

  const [pages, setPages] = useState<string[]>([]);

  const getPermits = useCallback(
    (page: string) => {
      const pageName = ROUTE_PATH_TO_ROUTE_KEY[page];
      if (!pageName) {
        return {
          canEdit: false,
          canCreate: false,
          canDelete: false,
          canRead: false,
        };
      }

      if (pageName && permissions.hasOwnProperty(pageName)) {
        const permits = permissions[pageName as keyof typeof permissions];

        return {
          canEdit: permits.includes("edit"),
          canCreate: permits.includes("create"),
          canDelete: permits.includes("delete"),
          canRead: permits.includes("get"),
        };
      }

      if (isDevelopment) {
        // console.warn(`${page} not found in permissions`);
      }

      return {
        canEdit: false,
        canCreate: false,
        canDelete: false,
        canRead: false,
      };
    },
    [permissions],
  );

  // pages: ["users", "admin", "entity"...]
  const [role, setRole] = useState("");
  // role: "admin", "entity", ""...etc
  const setPermissionsAndPages = (payload: any) => {
    setLoading(true);

    try {
      const { permissions = [] } = payload;
      // TODO, remove after permission added
      const renamedPermissions = Object.entries({
        ...permissions,
      })
        .map(([page, pagePermissions]) => {
          return routePagesFinder(page).map((pageName: string) => ({
            [pageName]: [...(pagePermissions as string[])],
          }));
        })
        .flat()
        .reduce((acc, curr) => ({ ...acc, ...curr }), {});

      const pages = Object.keys(renamedPermissions);
      setPermissions(renamedPermissions);

      setPages([
        ...pages,
        "EVENTS",
        "EVENT_REVIEW",
        "APPLICATION_FORMS",
        "DIRECTORY",
        "EVENT_ADD_ONS",
        "PRESETS",
        "WORKSPACES",
        "ADMINISTRATION",
        "STAFF",
        "STAFF_ROLES",
      ]);

      if (payload.hasOwnProperty("role")) {
        setRole(payload.role);
      }
    } catch (error) {
      console.error("Error in setPermissionsAndPages", error);
    } finally {
      setLoading(false);
    }
  };

  const value = {
    pages,
    role,
    permissions,
    isLoading,
    setPermissionsAndPages,
    getPermits,
  };

  return (
    <RoleContext.Provider value={value} test-id="l0n2QCpL">
      {children}
    </RoleContext.Provider>
  );
};

export default RoleProvider;
